import { makeStyles } from '@map/theme';

const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  staticContent: {
    ...typography.body1,
    '& h1': {
      color: palette.neutrals[900],
      marginTop: spacing(2),
      marginBottom: spacing(2),
      fontSize: 16,
    },
    '& p, & li': {
      marginTop: 5,
      fontSize: 14,
      lineHeight: 1.7,
    },
    '& ol': {
      paddingInlineStart: spacing(4),
    },
    '& ol ol': {
      paddingInlineStart: spacing(0.5),
    },
  },
}));

type Props = {
  content: string | undefined;
  className?: string;
};

const StaticPageContent = ({ content, className }: Props) => {
  const { classes, cx } = useStyles();
  return (
    <div
      className={cx(classes.staticContent, className)}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: content || '' }}
    />
  );
};

export default StaticPageContent;
